
















import { Component, Vue } from 'vue-property-decorator'
import { getMediumThumbnail } from '@/utils/resize'

@Component({
  props: {
    tag: {
      type: String,
      default: 'v-avatar',
    },
    size: {
      type: Number,
      default: 50,
    },
    src: {
      default: null,
    },
    name: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
})
export default class Avatar extends Vue {
  size!: number | string
  src!: string | null
  name!: string | null
  disabled!: boolean

  get initialsOfName() {
    if (!this.name) {
      return null
    }
    return this.name
      .trim()
      .split(' ')
      .slice(0, 2)
      .map((s) => s.trim())
      .filter((s) => s)
      .map((s) => s.slice(0, 1))
      .join('')
  }

  click(event: Event) {
    if (this.disabled) {
      return
    }
    this.$emit('click', event)
  }

  getThumbnail(src: string | null | undefined) {
    return getMediumThumbnail(src)
  }
}
